module.exports = __webpack_public_path__ + "img/tag_jingshen_icon@2x.5fe05d13.png";